<div mat-dialog-title class="dialog-title">
    <table *ngIf="!isMobile()">
        <tr>
            <td>
                <h4>Ítem Parametro</h4>
    </table>

    <table *ngIf="isMobile()">
        <tr>
            <td>
                <h6>Ítem Parametro</h6>

    </table>
    <button style="background-color: transparent; color:#10384f;" mat-mini-fab aria-label="Salir" mat-dialog-close>
        <mat-icon color="accent-darker">close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="form">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker" appearance="outline">
                        <mat-label>{{Etiquetas.DescripcionParametro}}</mat-label>
                        <mat-select [compareWith]="compareParametros" formControlName="idParametro">
                            <mat-option>- Seleccione -</mat-option>
                            <mat-option *ngFor="let parametro of parametros" [value]="parametro.id">
                                {{parametro.descripcion}}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="(form.get('idParametro').hasError('required')) && form.get('idParametro').touched ">
                            {{Validaciones.DescripcionParametro}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.IdItem}}</mat-label>
                        <input type="test" matInput formControlName="idItem">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('idItem')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        <mat-error
                            *ngIf="(form.get('idItem').hasError('required')) && form.get('idItem').touched">
                            {{Validaciones.Id}}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                    <mat-form-field color="accent-darker"  appearance="outline">
                        <mat-label>{{Etiquetas.Descripcion}}</mat-label>
                        <input type="text" matInput formControlName="descripcion">
                        <button *ngIf="!isInRole('CONSULTOR')" type="button" matSuffix mat-icon-button
                             (click)="clearInput('descripcion')">
                            <mat-icon color="accent-darker">close</mat-icon>
                        </button>
                        <!-- <mat-error
                            *ngIf="(form.get('descripcion').hasError('required')) && form.get('descripcion').touched ">
                            {{Validaciones.Descripcion}}
                        </mat-error> -->
                    </mat-form-field>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12" style="padding-bottom: 1%;">

                    <mat-checkbox class="cell" formControlName="habilitacion" color="primary-darker">
                        {{Etiquetas.Habilitacion}}
                    </mat-checkbox>

                </div>


            </div>
        </div>

    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button *ngIf="!isInRole('CONSULTOR')" [disabled]="form.invalid" (click)="guardarItemParametro()"
        mat-flat-button color="accent">Guardar</button>
    <button mat-dialog-close *ngIf="isInRole('CONSULTOR')" mat-flat-button color="accent">Salir</button>
</mat-dialog-actions>